import { isBookingPortal } from '@white-label-helper/is-booking-portal'

export const isBookingPortalFlow = (): boolean => {
  if(!window) return false
  const path = window.location.pathname;
  const hasBpPrefix = path.split('/').filter(Boolean)[0]  === 'booking-portal';
  return isBookingPortal() && hasBpPrefix;
};
